<template>
  <div
    class="grid grid-cols-4 w-full flex-flex-col flex-1 overflow-hidden gap-4"
  >
    <conversations-list
      :conversations="[...conversations, ...usersList]"
    ></conversations-list>
    <div
      class="flex flex-col flex-1 overflow-hidden col-span-3 mb-4 me-10 shadow-lg rounded-xl"
    >
      <div
        v-if="selectedConversation"
        class="flex flex-col flex-1 w-full overflow-hidden bg-white rounded-xl"
      >
        <!-- Header -->
        <div class="flex items-center gap-3 p-4 flex-shrink-0 border-b">
          <Avatar
            class="me-4"
            :image="
              selectedConversation.avatar
                ? selectedConversation.avatar
                : require('@/assets/user.png')
            "
            shape="circle"
            size="large"
          />
          <div>
            <div class="font-semiBold text-sm">
              {{ selectedConversation?.fullname }}
            </div>
          </div>
        </div>

        <!-- Messages -->
        <div class="flex flex-col flex-1 overflow-y-auto bg-surface-50 py-2">
          <div class="relative">
            <div
              v-if="observedDay"
              class="sticky top-0 left-1/2 transform -translate-x-1/2 w-fit text-white px-3 py-1 rounded-full text-sm z-10"
            >
              {{ observedDay }}
            </div>

            <div
              ref="messagesList"
              id="messagesList"
              class="overflow-y-auto px-3"
            >
              <div v-if="!conversationLoading">
                <div
                  v-for="(msg, i) in selectedConversation.messages
                    .slice()
                    .reverse()"
                  :key="i"
                  class="mb-1"
                >
                  <div :ref="`${msg.id}`" class="grid justify-items-stretch">
                    <div
                      v-if="
                        !isSameDayMessages(
                          msg.time,
                          i == 0
                            ? 0
                            : selectedConversation.messages.slice().reverse()[
                                i - 1
                              ].time
                        )
                      "
                      class="text-primary-900 text-sm my-2 w-fit justify-self-center bg-nature-grey py-1 px-2 rounded-lg"
                    >
                      {{ getConversationTime(msg.time, 3) }}
                    </div>

                    <div
                      v-if="msg.type === 1"
                      class="text-left text-sm text-primary-900 bg-white px-4 py-2 rounded-lg shadow-md my-2 w-fit justify-self-end"
                    >
                      {{ msg.message }}
                      <div class="text-xs text-gray-500 mt-1">
                        {{ getMessageTimeFormat(msg.time) }}
                      </div>
                    </div>
                    <div
                      v-else
                      class="text-left text-sm text-dark bg-nature-grey px-4 py-2 rounded-lg shadow-md my-2 w-fit justify-self-start"
                    >
                      {{ msg.message }}
                      <div class="text-xs text-gray-500 mt-1">
                        {{ getMessageTimeFormat(msg.time) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="flex justify-center p-4">
                <ProgressSpinner
                  style="width: 50px; height: 50px"
                  strokeWidth="8"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Input -->
        <div class="flex items-center gap-2 bg-white p-4 border-t">
          <Textarea
            v-model="messageText"
            autoResize
            rows="1"
            class="w-full"
            :placeholder="$t('chat.message_input_placeholder')"
            @keydown.enter="handleEnter"
          />
          <Button
            class="!text-primary-500 hover:!bg-primary-100 rounded-full p-2"
            @click="sendMessage"
          >
            <v-icon
              :class="[$i18n.locale === 'ar' ? 'transform scale-x-[-1]' : '']"
              >mdi-send</v-icon
            ></Button
          >
        </div>
      </div>
      <div class="flex flex-col items-center justify-center h-full" v-else>
        <h3 class="text-primary-900 text-sm">
          {{ $t("chat.introduction_description") }}
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { mapActions, mapGetters, mapMutations } from "vuex";
import ConversationsList from "./components/ConversationsList.vue";
import { Textarea, Button, Avatar, ProgressSpinner } from "primevue";

export default {
  components: {
    ConversationsList,
    Textarea,
    Button,
    Avatar,
    ProgressSpinner,
  },
  data() {
    return {
      isInit: false,
      observer: null,
      pullDownThreshold: 64,
      messagesLimit: 30,
      messagesLabels: [],
      observeList: [],
      observedDay: null,
      converseHeight: 0,
      focusSelect: false,
      searchedUser: "",
      selectedUser: "",
      selectedConversation: null,
      scrollInvoked: 0,
      conversationLoading: false,
      messageText: "",
      jumpToID: null,
      scrollBehavior: null,
      usersList: [],
      conversations: [],
    };
  },
  computed: {
    ...mapGetters([
      "getbaseURL",
      "uname",
      "notReadChatMessages",
      "incomingSocketMessage",
      "chatSocket",
      "differentTABSent",
      "differentTABRead",
      "currentChatID",
    ]),
    currentLocal() {
      return this.$vuetify.locale.current;
    },
    // currentMessagesOffset(){
    //   let offset  =
    // },
  },
  methods: {
    ...mapMutations([
      "setNotReadChatMessages",
      "setCurrentChatID",
      "setShowFooter",
    ]),
    ...mapActions([
      "GetUserConversations",
      "GetChatUsers",
      "GetChatConversationMessages",
      "ShowProgressBar",
      "SetMessageDialog",
    ]),
    async loadMoreMessages({ done }) {
      // Perform API call
      console.log("loading");
      try {
        const resp = await this.GetChatConversationMessages({
          conversation_id: this.selectedConversation.conversation_id,
          offset: this.selectedConversation.messages.length,
          limit: this.messagesLimit,
        });
        if (!resp.success) {
          done("ok");
          this.SetMessageDialog({ show: true, message: resp.message });
          return;
        }
        // this.messagesLabels = [];
        this.jumpToID =
          this.selectedConversation.messages[
            this.selectedConversation.messages.length - 1
          ].id;
        // console.log("My resp Messages", resp.messages);
        // this.selectedConversation.messages.push(...resp.messages);
        const converseIDX = this.getConversationIndex(
          this.selectedConversation.conversation_id
        );
        // this.conversations.findIndex(
        //   (converse) =>
        //     converse.conversation_id ==
        //     this.selectedConversation.conversation_id
        // );

        this.handleSelectedConversation(
          converseIDX,
          true,
          resp.messages,
          false
        );
        // this.conversations[converseIDX] = this.selectedConversation;
        // this.scrollBehavior = "instant";
        // this.scrollToLastMessage();
        // setTimeout(() => {
        //   this.setupObserver();
        // }, 500);
        done("ok");
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.conversationLoading = false;
        this.SetMessageDialog({ show: true, message: message });
        done("ok");
      }
      // console.log("load finish");
      // done("ok");
    },
    async initChat() {
      if (this.isInit) {
        return;
      }
      this.isInit = true;
      this.ShowProgressBar({
        show: true,
        message: this.$t("chat.init_chat"),
      });
      try {
        const userResp = await this.GetChatUsers();
        if (!userResp.success) {
          this.ShowProgressBar({ show: false, message: "" });
          this.SetMessageDialog({ show: true, message: userResp.message });
          return;
        }
        this.usersList = userResp.users;
        const conversResp = await this.GetUserConversations();
        if (!conversResp.success) {
          this.ShowProgressBar({ show: false, message: "" });
          this.SetMessageDialog({ show: true, message: conversResp.message });
          return;
        }
        const result = conversResp.conversations;
        const initConversations = [];
        for (const res of result) {
          const user = this.usersList.find((usr) => usr.uname == res.uname);
          const converse = { ...res, ...user, isSet: res.messages.length > 0 };
          initConversations.push(converse);
        }
        this.conversations = initConversations;
        this.ShowProgressBar({ show: false, message: "" });
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.ShowProgressBar({ show: false, message: "" });
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    onScroll() {
      this.scrollInvoked++;
    },
    setupObserver() {
      if (!this.$refs.messagesList) {
        return;
      }
      this.observeList = [];
      this.observedDay = null;
      // console.log("My setUpObserver", this.$refs.messagesList);
      if (this.observer) {
        this.observer.disconnect();
      }
      const options = {
        root: this.$refs.messagesList,
        rootMargin: "0px",
        threshold: 0.7,
      };
      this.observer = new IntersectionObserver(this.handleShowingDay, options);
      this.messagesLabels.forEach((messageDay) => {
        // console.log("My day Ele", messageDay, this.$refs[messageDay][0]);
        this.observer.observe(this.$refs[messageDay][0]);
      });
    },
    handleShowingDay(entries) {
      entries.forEach((entry) => {
        // console.log(
        //   "My intersecting, parent, entry , value",
        //   entry.isIntersecting,
        //   this.$refs.messagesList.scrollTop,
        //   entry.target.offsetTop,
        //   entry.target.innerText
        // );
        const value = entry.target.innerText;
        if (!this.observeList.includes(value)) {
          this.observeList.push(value);
          if (this.observeList.length != this.messagesLabels.length) {
            return;
          }
        }
        const parentOffset = this.$refs.messagesList.scrollTop;
        const isIntersect = entry.isIntersecting;
        const entryOffset = entry.target.offsetTop;
        const showPrevious = !isIntersect && parentOffset < entryOffset;
        const showValueCond =
          (isIntersect && parentOffset < entryOffset) ||
          (isIntersect && entryOffset < 0) ||
          (!isIntersect && parentOffset > entryOffset);
        if (value.toLowerCase() == this.$t("chat.time.today")) {
          if (showPrevious) {
            const idx = this.observeList.findIndex((val) => val == value);
            this.observedDay =
              idx != -1 && idx > 0 ? this.observeList[idx - 1] : value;
          } else {
            this.observedDay = null;
          }
          return;
        }
        if (showValueCond) {
          this.observedDay = value;
        } else if (showPrevious) {
          const idx = this.observeList.findIndex((val) => val == value);
          this.observedDay =
            idx != -1 && idx > 0 ? this.observeList[idx - 1] : value;
        }
      });
    },
    scrollToLastMessage() {
      this.$nextTick(() => {
        let jumpID;
        if (!this.jumpToID) {
          if (this.selectedConversation.messages.length == 0) {
            return;
          }
          jumpID = this.selectedConversation.messages[0].id;
        } else {
          jumpID = this.jumpToID;
        }
        let behavior = this.scrollBehavior;
        if (!this.scrollBehavior) {
          behavior = "instant";
        }
        this.$refs[jumpID][0]?.scrollIntoView({
          behavior,
        });
        this.jumpToID = null;
        this.scrollBehavior = null;
      });
    },
    changeFocus(ev) {
      this.focusSelect = ev;
    },
    openChattingSelect() {
      this.focusSelect = true;
    },
    onResize() {
      this.converseHeight = window.innerHeight;
    },
    handleSelectedUser(user) {
      this.$router.push(this.getbaseURL + "/Chat/" + user);
    },
    getMessageTimeFormat(msgTime) {
      return moment.unix(+msgTime).format("HH:mm");
    },
    getMessageDate(msgTime) {
      return moment.unix(+msgTime).format("YYYY-MM-DD");
    },

    isSameDayMessages(msgTime, prevMsgTime) {
      const messageDay = moment.unix(+msgTime).format("YYYY-MM-DD");
      const prevMessageDay = moment.unix(+prevMsgTime).format("YYYY-MM-DD");
      const sameDayCond = moment(messageDay).isSame(
        moment(prevMessageDay),
        "day"
      );
      if (sameDayCond) {
        return true;
      }
      if (!sameDayCond || msgTime == prevMessageDay) {
        if (!this.messagesLabels.includes(messageDay)) {
          this.messagesLabels.push(messageDay);
        }
      }
      return false;
    },
    getConversationTime(lastTime, type) {
      const messageDay = moment.unix(+lastTime).format("YYYY-MM-DD");
      const today = moment().format("YYYY-MM-DD");
      const sameDayCond = moment(messageDay).isSame(moment(today), "day");
      if (sameDayCond && type != 3) {
        return moment.unix(+lastTime).format("HH:mm");
      } else if (sameDayCond && type == 3) {
        return this.$t("chat.time.today");
      }
      if (moment(today).diff(moment(messageDay), "days") == 1) {
        return this.$t("chat.time.yesterday");
      }
      const weekEarlier = moment().add(-7, "days").format("YYYY-MM-DD");
      if (moment(weekEarlier).isBefore(moment(messageDay))) {
        return moment.unix(+lastTime).locale(this.currentLocal).format("dddd");
        // return moment.unix(+lastTime).format("dddd");
      }
      return messageDay;
    },
    setMessagesToRead(notReadMSG, converseID) {
      if (notReadMSG.length == 0) {
        return;
      }
      const newNotReadMessages = this.notReadChatMessages.filter(
        (notRead) => !notReadMSG.includes(notRead.message_id)
      );
      this.setNotReadChatMessages(newNotReadMessages);
      this.jumpToID = notReadMSG[0];
      console.log("My setMessages To Read~~~", converseID);
      this.chatSocket.send(
        JSON.stringify({
          type: 4,
          not_read: notReadMSG,
          conversation_id: converseID,
        })
      );
      // notReadMSG = [];
      // return;
    },
    createConverseID(firstPeer, secondPeer) {
      if (firstPeer < secondPeer) {
        return firstPeer + "_" + secondPeer;
      } else {
        return secondPeer + "_" + firstPeer;
      }
    },
    sendMessage(e) {
      e.preventDefault();
      if (this.messageText.trim() == "") {
        return;
      }
      let message = {
        message: this.messageText.trim(),
        time: moment().unix().toString(),
        type: 1,
        id: uuidv4(),
      };
      let exist = this.selectedConversation.messages.length > 0;
      this.chatSocket.send(
        JSON.stringify({
          type: 1,
          message_id: message.id,
          from: this.uname,
          to: this.selectedConversation.uname,
          text: message.message,
          conversation_id: this.selectedConversation.conversation_id,
          time: message.time,
          is_read: false,
        })
      );
      let isSamePrevMsgDay = true;
      if (exist) {
        isSamePrevMsgDay = this.isSameDayMessages(
          message.time,
          this.selectedConversation.messages[0].time
        );
      }
      const idx = this.getConversationIndex(
        this.selectedConversation.conversation_id
      );

      //  this.conversations.findIndex(
      //     (converse) =>
      //       converse.conversation_id ==
      //       this.selectedConversation.conversation_id
      //   );
      this.scrollBehavior = "smooth";
      this.handleSelectedConversation(idx, !isSamePrevMsgDay, [message], true);
      this.messageText = "";

      // if (!isSamePrevMsgDay) {
      //   this.messagesLabels = [];
      // }
      // this.selectedConversaexiston.last_time = message.time;
      // this.selectedConversation.count += 1;

      // if (exist) {
      //   let idx;
      //   this.conversations.map((converse, index) => {
      //     if (converse.uname == this.selectedConversation.uname) {
      //       this.conversations[index] = this.selectedConversation;
      //       idx = index;
      //       return;
      //     }
      //   });
      //   this.conversations.unshift(this.conversations.splice(idx, 1)[0]);
      // } else {
      //   this.conversations.unshift(this.selectedConversation);
      // }
      // this.scrollBehavior = "smooth";
      // this.scrollToLastMessage();
      // this.messageText = "";
      // if (!isSamePrevMsgDay) {
      //   setTimeout(() => {
      //     // const dayID = moment.unix(+message.time).format("YYYY-MM-DD");
      //     // this.observer.observe(this.$refs[dayID][0]);
      //     this.setupObserver();
      //   }, 500);
      // }
    },

    async setUserConversation(username) {
      this.conversationLoading = true;
      // this.messagesLabels = [];
      const converseIDX = this.conversations.findIndex(
        (element) => element.uname == username
      );
      let conversation;
      if (converseIDX == -1) {
        const converseUser = this.usersList.find(
          (element) => element.uname == username
        );
        conversation = {
          ...converseUser,
          conversation_id: this.createConverseID(username, this.uname),
          isSet: true,
          messages: [],
          last_message: "",
          last_time: "",
          count: 0,
          not_read_msgs: [],
        };
        // this.selectedConversation = newConversation;
        // this.setCurrentChatID(JSON.parse(JSON.stringify(newConversation)));
        // this.handleSelectedConversation(converseIDX, true,[],newConversation )
        // this.searchedUser = "";
        // this.selectedUser = "";
        // this.scrollBehavior = "instant";
        // return;
      } else if (this.conversations[converseIDX].isSet) {
        conversation = JSON.parse(
          JSON.stringify(this.conversations[converseIDX])
        );
      } else if (!this.conversations[converseIDX].isSet) {
        conversation = JSON.parse(
          JSON.stringify(this.conversations[converseIDX])
        );
        try {
          const resp = await this.GetChatConversationMessages({
            conversation_id: conversation.conversation_id,
            offset: 0,
            limit: this.messagesLimit,
          });

          if (!resp.success) {
            this.conversationLoading = false;
            this.SetMessageDialog({ show: true, message: resp.message });
            return;
          }
          // converse.isSet = true;
          conversation.messages = resp.messages;
          conversation.not_read_msgs = resp.not_read_msgs;
          // converse = this.setMessagesToRead(converse);
          // this.conversations[converseIDX] = converse;
          // this.setCurrentChatID(JSON.parse(JSON.stringify(converse)));
        } catch (err) {
          let message = err.message;
          if (err.response) {
            message = err.response.data.message;
          }
          this.conversationLoading = false;
          this.SetMessageDialog({ show: true, message: message });
        }
      }
      this.handleSelectedConversation(
        converseIDX,
        true,
        [],
        false,
        conversation
      );
      // let converse = this.conversations[converseIDX];
      // if (converse.isSet) {
      //   // converse = this.setMessagesToRead(converse);
      //   // this.conversations[converseIDX] = converse;
      //   // this.setCurrentChatID(JSON.parse(JSON.stringify(converse)));
      //   // this.selectedConversation = converse;
      //   // this.scrollToLastMessage(true, jumpToID);
      // } else {
      //   try {
      //     const resp = await this.GetChatConversationMessages({
      //       conversation_id: converse.conversation_id,
      //       offset: 0,
      //       limit: this.messagesLimit,
      //     });

      //     if (!resp.success) {
      //       this.conversationLoading = false;
      //       this.SetMessageDialog({ show: true, message: resp.message });
      //       return;
      //     }
      //     converse.isSet = true;
      //     converse.messages = resp.messages;
      //     converse.not_read_msgs = resp.not_read_msgs;
      //     converse = this.setMessagesToRead(converse);
      //     this.conversations[converseIDX] = converse;
      //     this.setCurrentChatID(JSON.parse(JSON.stringify(converse)));
      //   } catch (err) {
      //     let message = err.message;
      //     if (err.response) {
      //       message = err.response.data.message;
      //     }
      //     this.conversationLoading = false;
      //     this.SetMessageDialog({ show: true, message: message });
      //   }
      // }
      this.searchedUser = "";
      this.selectedUser = "";
    },

    handleSelectedConversation(
      idx,
      isDiffrentDay,
      messages,
      fromStart,
      conversation
    ) {
      if (isDiffrentDay) {
        this.messagesLabels = [];
      }
      if (!conversation) {
        conversation = JSON.parse(JSON.stringify(this.selectedConversation));
      }
      if (messages.length > 0) {
        if (fromStart) {
          conversation.messages.unshift(...messages);
          conversation.last_time = messages[0].time;
          conversation.last_message = messages[0].message;
        } else {
          conversation.messages.push(...messages);
        }
        conversation.count += messages.length;
      }
      if (conversation.messages.length > 0 && !conversation.isSet) {
        conversation.isSet = true;
      }

      // console.log(
      //   "before calling message to read",
      //   conversation.conversation_id,
      //   conversation.not_read_msgs
      // );
      this.setMessagesToRead(
        conversation.not_read_msgs,
        conversation.conversation_id
      );
      conversation.not_read_msgs = [];
      this.selectedConversation = JSON.parse(JSON.stringify(conversation));
      this.conversationLoading = false;
      if (conversation.messages.length > 0) {
        if (idx == -1) {
          this.conversations.unshift(JSON.parse(JSON.stringify(conversation)));
        } else {
          this.conversations[idx] = JSON.parse(JSON.stringify(conversation));
          if (fromStart) {
            this.conversations.unshift(this.conversations.splice(idx, 1)[0]);
          }
        }
      }
      if (isDiffrentDay) {
        setTimeout(() => {
          this.setupObserver();
        }, 500);
      }
      this.scrollToLastMessage();
    },
    getConversationIndex(converseID) {
      return this.conversations.findIndex(
        (converse) => converse.conversation_id == converseID
      );
    },
    handleEnter(e) {
      if (e.shiftKey) return; // Allow newline
      e.preventDefault();
      this.sendMessage(e);
    },
  },
  watch: {
    "$route.params.user": {
      handler: async function (value) {
        // console.log("My route params!!!!", this.conversations);
        if (!value) {
          return;
        }
        if (this.usersList.length == 0) {
          await this.initChat();
          // this.selectedConversation.uname = value;
          // return;
        }
        this.setUserConversation(value);
      },
      deep: true,
      immediate: true,
    },
    selectedConversation: {
      handler: async function (value) {
        // console.log("My route params!!!!", this.conversations);
        if (!value) {
          return;
        }
        this.setCurrentChatID(value.conversation_id);
      },
      deep: true,
      immediate: true,
    },
    notReadChatMessages: {
      handler: async function (newVal, oldVal) {
        // console.log("My not read chat messages!!!", this.conversations);
        const isNewMessage = !oldVal || newVal.length > oldVal?.length;
        if (!isNewMessage) {
          return;
        }
        for (const message of newVal) {
          const idx = this.getConversationIndex(message.conversation_id);

          // this.conversations.findIndex(
          //   (converse) => converse.conversation_id ==
          // );

          const newMessage = {
            message: message.text,
            id: message.message_id,
            time: message.time,
            type: 2,
            is_read: message.is_read,
          };
          if (idx == -1) {
            const user = this.usersList.find(
              (usr) => usr.uname == message.from
            );

            const NewConversation = {
              avatar: user.avatar,
              uname: user.uname,
              conversation_id: message.conversation_id,
              fullname: user.fullname,
              isSet: true,
              count: 1,
              messages: [newMessage],
              last_message: message.text,
              last_time: message.time,
              not_read_msgs: [newMessage.id],
            };
            this.conversations.unshift(NewConversation);
          } else {
            const msgIDX = this.conversations[idx].messages.findIndex(
              (msg) => msg.id == newMessage.id
            );
            const notmsgIDX = this.conversations[idx].not_read_msgs.findIndex(
              (msgID) => msgID == newMessage.id
            );
            if (msgIDX != -1 && notmsgIDX == -1) {
              return;
            }

            this.conversations[idx].last_message = newMessage.message;
            this.conversations[idx].last_time = newMessage.time;
            this.conversations[idx].count += 1;
            if (
              this.conversations[idx].not_read_msgs.length > 0 &&
              this.conversations[idx].not_read_msgs[0] == "i"
            ) {
              console.log("My not read in th IF");
              this.conversations[idx].not_read_msgs = [newMessage.id];
            } else {
              this.conversations[idx].not_read_msgs.push(newMessage.id);
              console.log("My not read in the Else");
            }
            if (this.conversations[idx].isSet) {
              this.conversations[idx].messages.unshift(newMessage);
            }
            this.conversations.unshift(this.conversations.splice(idx, 1)[0]);
          }
        }
      },
      deep: true,
    },
    incomingSocketMessage: {
      handler: function (incomingMSG) {
        if (!incomingMSG) {
          return;
        }
        const inSelectedCond =
          this.selectedConversation &&
          this.selectedConversation?.conversation_id ==
            incomingMSG.conversation_id;
        if (!inSelectedCond) {
          return;
        }
        const msgIDX = this.selectedConversation.messages.findIndex(
          (message) => incomingMSG.message_id == message.id
        );
        if (msgIDX != -1) {
          return;
        }
        const msgToPush = {
          message: incomingMSG.text,
          id: incomingMSG.message_id,
          time: incomingMSG.time,
          type: 2,
          is_read: true,
        };
        console.log("My msgToPush", msgToPush);
        this.scrollBehavior = "smooth";
        let isSamePrevMsgDay = true;
        if (this.selectedConversation.messages.length > 0) {
          isSamePrevMsgDay = this.isSameDayMessages(
            msgToPush.time,
            this.selectedConversation.messages[0].time
          );
        }
        const idx = this.getConversationIndex(
          this.selectedConversation.conversation_id
        );
        this.handleSelectedConversation(
          idx,
          !isSamePrevMsgDay,
          [msgToPush],
          true
        );
      },
      deep: true,
      // immediate: true,
    },
    differentTABRead: {
      handler: function (readMSG) {
        if (!readMSG) {
          return;
        }
        const idx = this.getConversationIndex(readMSG.conversation_id);
        console.log("My chat page differentTABRead:", readMSG, idx);
        if (idx == -1) {
          return;
        }
        const newNotRead = this.conversations[idx].not_read_msgs.filter(
          (msgID) => !readMSG.not_read.includes(msgID)
        );
        this.conversations[idx].not_read_msgs = newNotRead;
      },
      deep: true,
      // immediate: true,
    },
    differentTABSent(tabMessage) {
      if (!tabMessage) {
        return;
      }
      const newMessage = {
        message: tabMessage.text,
        id: tabMessage.message_id,
        time: tabMessage.time,
        type: 1,
        is_read: true,
      };
      const idx = this.getConversationIndex(tabMessage.conversation_id);
      // this.conversations.findIndex(
      //   (converse) => converse.conversation_id == tabMessage.conversation_id
      // );
      if (idx == -1) {
        const user = this.usersList.find((usr) => usr.uname == tabMessage.to);
        const NewConversation = {
          avatar: user.avatar,
          uname: user.uname,
          conversation_id: tabMessage.conversation_id,
          fullname: user.fullname,
          isSet: true,
          count: 1,
          messages: [newMessage],
          last_message: tabMessage.text,
          last_time: tabMessage.time,
          not_read_msgs: [],
        };
        this.conversations.unshift(NewConversation);
        return;
      }
      if (this.currentChatID == tabMessage.conversation_id) {
        // console.log("My msgToPush", msgToPush);
        this.scrollBehavior = "smooth";
        let isSamePrevMsgDay = true;
        if (this.selectedConversation.messages.length > 0) {
          isSamePrevMsgDay = this.isSameDayMessages(
            newMessage.time,
            this.selectedConversation.messages[0].time
          );
        }
        const idx = this.getConversationIndex(
          this.selectedConversation.conversation_id
        );
        this.handleSelectedConversation(
          idx,
          !isSamePrevMsgDay,
          [newMessage],
          true
        );
        return;
      }

      // const msgIDX = this.conversations[idx].messages.findIndex(
      //   (msg) => msg.id == newMessage.id
      // );
      // if (msgIDX != -1) {
      //   return;
      // }
      this.conversations[idx].last_message = newMessage.message;
      this.conversations[idx].last_time = newMessage.time;
      this.conversations[idx].count += 1;
      this.conversations[idx].messages.unshift(newMessage);
      this.conversations[idx].isSet = true;
      this.conversations.unshift(this.conversations.splice(idx, 1)[0]);
    },
  },
  async created() {
    await this.initChat();
  },
  mounted() {
    this.onResize();
    this.setShowFooter(false);
  },
  unmounted() {
    this.setCurrentChatID(null);
    this.setShowFooter(true);
    // this.setCurrentChatID(null);
  },
};
</script>

<style scoped>
.sent-messages-en {
  color: #fff;
  font-size: 14px;
  max-width: 50ch;
  min-width: 8ch;
  text-align: start;
  margin-right: 6px;
  float: inline-end;
}
.sent-messages-ar {
  color: #fff;
  font-size: 14px;
  max-width: 50ch;
  min-width: 8ch;
  text-align: end;
  margin-right: 6px;
  float: inline-start;
}
.sent-messages {
  /* triangle dimension */
  --b: 2em; /* base */
  --h: 0.5em;

  --p: 100%; /* triangle position (0%:top 100%:bottom) */
  --r: 10px; /* the radius */
  --c: #00796b;

  padding: 0.8em;
  border-radius: var(--r) / var(--r) min(var(--r), var(--p) - var(--b) / 2)
    min(var(--r), 100% - var(--p) - var(--b) / 2) var(--r);
  clip-path: polygon(
    100% 100%,
    0 100%,
    0 0,
    100% 0,
    100% max(0%, var(--p) - var(--b) / 2),
    calc(100% + var(--h)) var(--p),
    100% min(100%, var(--p) + var(--b) / 2)
  );

  background: var(--c);
  border-image: conic-gradient(var(--c) 0 0) fill 0 /
    calc(var(--p) - var(--b) / 2) 0 calc(100% - var(--p) - var(--b) / 2)
    var(--r) / 0 var(--h) 0 0;
}

/* HTML: <div class="tooltip">This is a Speech Bubble with a solid coloration and with border radius </div> */
.received-messages-en {
  color: #eeeeee;
  font-size: 14px;
  max-width: 50ch;
  min-width: 10ch;
  text-align: start;
  margin-left: 6px;
  float: inline-start;
}
.received-messages-ar {
  color: #eeeeee;
  font-size: 14px;
  max-width: 50ch;
  min-width: 10ch;
  text-align: end;
  margin-left: 6px;
  float: inline-end;
}
.received-messages {
  /* triangle dimension */
  --b: 2em; /* base */
  --h: 0.5em;

  --p: 0%; /* triangle position (0%:top 100%:bottom) */
  --r: 10px; /* the radius */
  --c: #757575;

  padding: 0.8em;
  border-radius: var(--r) / min(var(--r), var(--p) - var(--b) / 2) var(--r)
    var(--r) min(var(--r), 100% - var(--p) - var(--b) / 2);
  clip-path: polygon(
    0 100%,
    100% 100%,
    100% 0,
    0 0,
    0 max(0%, var(--p) - var(--b) / 2),
    calc(-1 * var(--h)) var(--p),
    0 min(100%, var(--p) + var(--b) / 2)
  );
  background: var(--c);
  border-image: conic-gradient(var(--c) 0 0) fill 0 /
    calc(var(--p) - var(--b) / 2) var(--r) calc(100% - var(--p) - var(--b) / 2)
    0/ 0 0 0 var(--h);
}

.nav-item-style .v-list-item-subtitle {
  font-size: 0.9rem !important;
  line-height: 1.2rem !important;
  white-space: initial !important;
}
</style>
